import { type OutgoingHttpHeaders } from 'node:http';

import { defaultPlacementMiddleware } from '../default-placement-middleware';
import { type PlacementMiddleware } from '../types';

export const customHeadersMiddleware =
	(headers: Record<keyof OutgoingHttpHeaders, string>): PlacementMiddleware =>
	(config) =>
	async (opts) => {
		const isCustomHeadersEnabled =
			opts.request.orchestrationContext.recipient?.userId &&
			opts.request.statsig.checkGate(
				{ identifiers: { atlassianAccountId: opts.request.orchestrationContext.recipient.userId } },
				'post-office-custom-headers-v2',
			);

		const isPostOfficeSynthetic =
			opts.request.orchestrationContext.recipient?.userId &&
			opts.request.statsig.checkGate(
				{ identifiers: { atlassianAccountId: opts.request.orchestrationContext.recipient.userId } },
				'post-office-is-post-office-synthetic',
			);

		if (isCustomHeadersEnabled && !isPostOfficeSynthetic) {
			opts.koa.ctx.set(headers);
		}

		return defaultPlacementMiddleware(config)(opts);
	};

export const DEFAULT_PLACEMENT_MIDDLEWARE_CACHE_CONTROL =
	'private, max-age=300, stale-while-revalidate=600, stale-if-error=900';
export const GLOBAL_PLACEMENT_MIDDLEWARE_CACHE_CONTROL =
	'private, max-age=120, stale-while-revalidate=300, stale-if-error=900';
export const INTERACTION_PLACEMENT_MIDDLEWARE_CACHE_CONTROL =
	'private, max-age=600, stale-while-revalidate=900, stale-if-error=900';

export const placementMiddlewareWithCacheControlDefault = customHeadersMiddleware({
	['cache-control']: DEFAULT_PLACEMENT_MIDDLEWARE_CACHE_CONTROL,
});

export const placementMiddlewareWithCacheControlHome = customHeadersMiddleware({
	['cache-control']: DEFAULT_PLACEMENT_MIDDLEWARE_CACHE_CONTROL,
});

export const placementMiddlewareWithCacheControlIssueView = customHeadersMiddleware({
	['cache-control']: DEFAULT_PLACEMENT_MIDDLEWARE_CACHE_CONTROL,
});

export const placementMiddlewareWithCacheControlGlobal = customHeadersMiddleware({
	['cache-control']: GLOBAL_PLACEMENT_MIDDLEWARE_CACHE_CONTROL,
});

export const placementMiddlewareWithCacheControlNav = customHeadersMiddleware({
	['cache-control']: GLOBAL_PLACEMENT_MIDDLEWARE_CACHE_CONTROL,
});

export const placementMiddlewareWithCacheControlInteraction = customHeadersMiddleware({
	['cache-control']: INTERACTION_PLACEMENT_MIDDLEWARE_CACHE_CONTROL,
});
